/* Step 13 · P3 · lane S13C (owner card "AZEX Step 13 Card V2", item S5 — the Audit trail screen is paged; the export stays the
   full trail). EN + AR of the pager under the trail table. No standard paragraph is quoted. */
const I18N_S13_P3_SPEED = {
  en: {
    w13Pager: {
      range: "Rows {from}–{to} of {n}",
      page: "Page {p} of {pages}",
      first: "First",
      prev: "Previous",
      next: "Next",
      last: "Last",
      exportFull: "The export holds every row of the filtered trail, not only this page.",
    },
  },
  ar: {
    w13Pager: {
      range: "السجلات {from}–{to} من {n}",
      page: "الصفحة {p} من {pages}",
      first: "الأولى",
      prev: "السابقة",
      next: "التالية",
      last: "الأخيرة",
      exportFull: "يتضمن التصدير كل سجلات السجل المُصفّى، لا هذه الصفحة وحدها.",
    },
  },
};

export default I18N_S13_P3_SPEED;
